import { cn } from '~/utils/cn';

import { Text } from '../../atoms/Text/view';

interface PropsQuoteTrend {
  pct: number | null;
  className?: string;
  compact?: boolean;
}

export default function QuoteTrend({ pct, className, compact }: PropsQuoteTrend) {
  const direction = pct == null ? 'flat' : pct > 0 ? 'up' : pct < 0 ? 'down' : 'flat';
  const color =
    direction === 'up' ? 'color-success-06' :
    direction === 'down' ? 'color-warning-06' : 'color-intense-06';
  const arrow = direction === 'up' ? '▲' : direction === 'down' ? '▼' : '·';

  return (
    <Text className={cn(compact ? 'text-captionMD' : 'text-bodyMD', color, className)}>
      {arrow} {pct == null ? '—' : `${pct.toFixed(2)}%`}
    </Text>
  );
}
